<template>
  <div class="columns is-mobile">
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Active</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="active" :disabled="loading">
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Role</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="role" :disabled="loading">
              <option value="all">All</option>
              <option value="admin">Admin</option>
              <option value="engineer">Engineer</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Sort</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="sort" :disabled="loading">
              <option value="-createdAt">Newest First</option>
              <option value="createdAt">Oldest First</option>
              <option value="name">Name A-Z</option>
              <option value="-name">Name Z-A</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      role: "all",
      active: "all",
      sort: "-createdAt"
    };
  },
  computed: {
    loading() {
      let component = this;
      return component.$store.getters["user/loading"];
    }
  },
  methods: {
    refresh() {
      let component = this;
      component.$store.dispatch("user/index");
    }
  },
  watch: {
    role() {
      let component = this;
      component.$store.commit("user/role", component.role);
      component.refresh();
    },
    active() {
      let component = this;
      component.$store.commit("user/active", component.active);
      component.refresh();
    },
    sort() {
      let component = this;
      component.$store.commit("user/sort", component.sort);
      component.refresh();
    }
  }
};
</script>
